var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 43",
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo_symbol@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iteration-in-progress",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "White-header",
    transform: "translate(-27.000000, -21.000000)",
    fill: "#5096E8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo_symbol",
    transform: "translate(27.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.634615, 0.632353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.959341,5.16299854 C21.959341,8.01463952 19.6551269,10.3262583 16.8126204,10.3262583 C13.970114,10.3262583 11.6658999,8.01463952 11.6658999,5.16299854 C11.6658999,2.31161882 13.970114,4.94245168e-14 16.8126204,4.94245168e-14 C19.6551269,4.94245168e-14 21.959341,2.31161882 21.959341,5.16299854",
    id: "Fill-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3429776,23.8829581 C17.1323764,27.3601945 18.2433595,30.4395008 16.2082204,30.9404539 C12.638827,31.8190656 7.20449015,17.3180846 14.8552493,15.2951117 C18.7442443,14.2665473 22.6495935,18.6820988 19.3429776,23.8829581 Z",
    id: "Fill-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.627123621,11.9685642 C-0.923267409,13.6184555 0.46112946,16.5227128 4.11522539,16.1107385 C6.55814784,15.835092 7.93642767,17.0787412 8.72774992,16.2069406 C10.1154834,14.6776758 3.6773011,8.72261484 0.627123621,11.9685642",
    id: "Fill-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26360504,34.2556354 C1.96610512,32.7936298 3.15600482,30.2447806 6.23862807,30.6294111 C8.29945988,30.8865992 9.47238447,29.8000115 10.1341396,30.5725994 C11.2950173,31.9276353 5.81589335,37.1323036 3.26360504,34.2556354",
    id: "Fill-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9830062,6.9324323 C33.1126984,8.91367982 31.9630489,13.0434212 27.5415775,13.0589593 C24.5852964,13.0694122 23.1577036,14.9605388 22.0659823,13.9093165 C20.1507354,12.0653692 26.7935256,3.03519723 30.9830062,6.9324323",
    id: "Fill-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0994125,41.0702165 C27.3612345,40.2021078 27.5940085,36.9627615 24.0520765,35.8201499 C21.6843144,35.0563735 21.0683902,33.3424562 19.8986345,33.8128808 C17.8472214,34.6379823 20.6496324,42.7780279 25.0994125,41.0702165",
    id: "Fill-18"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.12658a12d98a61f1b49c1842968036b1.svg";
export { ForwardRef as ReactComponent };